var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { Visibility } from './_definitions/ActionGroupDefinitions';
/**
 * This component is given array of items, displayedElements and hiddenElements from action group. With those props it
 * calculates the position of the overflow menu and adds the menu to the displayedElements array.
 * @param param0
 * @returns
 */
var ElementsWrapper = function (_a) {
    var children = _a.children, displayedElements = _a.displayedElements, items = _a.items, menuPropsPosition = _a.menuPropsPosition, displayOverflowMenu = _a.displayOverflowMenu;
    // Hook for storing the count of always visible elements positioned after the overflow menu.
    // This is needed for calculating the menu position within the displayed elements.
    var _b = useState(0), nrOfAlwaysVisibleElementsAfterMenu = _b[0], setNrOfAlwaysVisibleElementsAfterMenu = _b[1];
    /**
     * Returns a menu position index within the list of items. Be default it is the last item.
     * However, if the menu position is specified and all the items with no visibility set are put into the menu
     * (due to insufficient space) then it keeps the position between the always visible items.
     *
     * @returns A calculated menu position index.
     */
    var calculateMenuPositionIndex = function () {
        var idx;
        var menuPos = Number(menuPropsPosition);
        if (menuPos > 0 && menuPos < items.length) {
            idx = Math.min(menuPos - 1, displayedElements.length - nrOfAlwaysVisibleElementsAfterMenu);
        }
        else {
            idx = items.length - 1;
        }
        return idx;
    };
    /**
     * This `useEffect` is for finding all the always visible elements after the desired menu position.
     * Dependencies: when either the items' count and/or the menu position changes.
     */
    useEffect(function () {
        var count = 0;
        var menuPos = Number(menuPropsPosition);
        if (menuPos > 0 && menuPos < items.length) {
            for (var i = menuPos - 1; i < items.length; i += 1) {
                if (items[i].visibility === Visibility.ALWAYS) {
                    count += 1;
                }
            }
        }
        // Avoid unnecessary redraws.
        if (nrOfAlwaysVisibleElementsAfterMenu !== count) {
            setNrOfAlwaysVisibleElementsAfterMenu(count);
        }
    }, [items.length, menuPropsPosition]);
    var menuPosition = calculateMenuPositionIndex();
    // Add children to correct position. Runs only when memo below calls it.
    function insertMenu() {
        var copy = __spreadArray([], displayedElements, true);
        copy.splice(menuPosition, 0, children);
        return copy;
    }
    return React.createElement(React.Fragment, null, displayOverflowMenu ? insertMenu() : displayedElements);
};
export default React.memo(ElementsWrapper);
